import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wallet, ShoppingCart, Clock, Users, Mail, Gift, Star, MessageCircle, CheckCircle2, XCircle } from "lucide-react";
import { adminApi, money, fmtDate } from "../lib/api";
import { Card, Title, Badge, STATUS } from "./kit";

const INT = { comgate: "Comgate", idoklad: "iDoklad", mailerlite: "MailerLite", messenger: "Messenger (Meta)", email: "E-maily (Resend)", ai_bot: "AI robot" };

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    adminApi.get("/stats").then((r) => setS(r.data));
  }, []);
  if (!s) return null;
  const max = Math.max(1, ...s.chart.map((c) => c.value));
  const tiles = [[Wallet, "Tržby celkem", money(s.revenue)], [ShoppingCart, "Zaplacené objednávky", s.orders_paid], [Clock, "Čeká na platbu", s.orders_pending], [Users, "Zákazníci", s.customers], [Mail, "Odběratelé", s.subscribers], [Gift, "Prodané poukazy", s.vouchers_sold], [Star, "Hodnocení", s.reviews], [MessageCircle, "Nepřečtené zprávy", s.unread_messages]];
  return (
    <div data-testid="admin-dashboard">
      <Title>Přehled</Title>
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
        {tiles.map(([I, l, v], i) => (
          <Card key={l} data-testid={`admin-stat-${i}`}><I className="w-5 h-5 text-[var(--pink)]" /><p className="text-2xl font-extrabold mt-3">{v}</p><p className="text-sm text-[var(--muted)]">{l}</p></Card>
        ))}
      </div>
      <div className="grid xl:grid-cols-[2fr_1fr] gap-4 mt-4">
        <Card>
          <p className="font-display text-lg mb-4">Tržby za 30 dní</p>
          <div className="flex items-end gap-1 h-44">
            {s.chart.map((c) => <div key={c.date} title={`${c.date}: ${money(c.value)}`} className="flex-1 rounded-t-md bg-[var(--pink-soft)] hover:bg-[var(--pink)] transition-colors" style={{ height: `${Math.max(3, (c.value / max) * 100)}%` }} />)}
          </div>
        </Card>
        <Card>
          <p className="font-display text-lg mb-4">Napojení</p>
          <div className="space-y-2">
            {Object.entries(INT).map(([k, l]) => (
              <div key={k} className="flex items-center justify-between text-sm" data-testid={`integration-${k}`}>{l}{s.integrations[k] ? <span className="flex items-center gap-1 text-[#2b8f8a] font-bold"><CheckCircle2 className="w-4 h-4" /> aktivní</span> : <span className="flex items-center gap-1 text-[var(--muted)]"><XCircle className="w-4 h-4" /> čeká na klíče</span>}</div>
            ))}
          </div>
        </Card>
      </div>
      <div className="grid xl:grid-cols-2 gap-4 mt-4">
        <Card>
          <div className="flex justify-between mb-3"><p className="font-display text-lg">Poslední objednávky</p><Link to="/admin/objednavky" className="text-sm font-bold text-[var(--pink-dark)]">Vše</Link></div>
          {s.recent_orders.length === 0 && <p className="text-sm text-[var(--muted)]">Zatím žádné objednávky.</p>}
          {s.recent_orders.map((o) => (
            <div key={o.id} className="flex items-center justify-between py-2 border-b border-dashed border-[#f1e4ea] last:border-0 text-sm"><span><b>{o.number}</b> · {o.email}</span><span className="flex items-center gap-2"><Badge tone={STATUS[o.status][1]}>{STATUS[o.status][0]}</Badge>{money(o.total)}</span></div>
          ))}
        </Card>
        <Card>
          <p className="font-display text-lg mb-3">Nejprodávanější</p>
          {s.top_products.map((p) => <div key={p.name} className="flex justify-between py-2 text-sm border-b border-dashed border-[#f1e4ea] last:border-0"><span>{p.name}</span><span className="font-bold">{p.sold}×</span></div>)}
          <p className="text-xs text-[var(--muted)] mt-3">Aktualizováno {fmtDate(new Date())}</p>
        </Card>
      </div>
    </div>
  );
}
